import { RedirectionActionTypes, SET_REDIRECTION } from "./types"

const initialState = ""

export function redirectionReducer(
  state = initialState,
  action: RedirectionActionTypes,
) {
  switch (action.type) {
    case SET_REDIRECTION:
      return action.payload
    default:
      return state
  }
}
